import { render, staticRenderFns } from "./StringCopyTooltip.vue?vue&type=template&id=c12f821e&scoped=true&"
import script from "./StringCopyTooltip.vue?vue&type=script&lang=js&"
export * from "./StringCopyTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12f821e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
